import Transform from "@ember-data/serializer/transform";
import type { DiabguideRecommendationArgs } from "parog-web/models/diabguide-recommendation";
import DiabguideRecommendation from "parog-web/models/diabguide-recommendation";

export interface DiabguideRecommendationDataDeserialized {
  "cardio-risk": Record<string, unknown>;
  "glycemic-objectives": {
    hba: string;
    subtitle: string;
    note: string;
  };
  "lipid-objectives": {
    ldl: string;
    note: string;
  };
  "blood-pressure-objectives": {
    systolic: {
      label: string;
    };
    diastolic: {
      label: string;
    };
    note: string;
  };
  "therapeutic-strategy": Record<string, unknown>[];
}

export default class DiabguideRecommendationTransform extends Transform {
  deserialize(
    serialized: DiabguideRecommendationArgs
  ): DiabguideRecommendation | undefined {
    if (!serialized) return undefined;
    return new DiabguideRecommendation(serialized);
  }

  serialize(
    deserialized: DiabguideRecommendation
  ): DiabguideRecommendationArgs | undefined {
    if (!deserialized) return undefined;
    return deserialized.serialize();
  }
}

declare module "ember-data/types/registries/transform" {
  export default interface TransformRegistry {
    "diabguide-recommendation": DiabguideRecommendationTransform;
  }
}
